import { render, staticRenderFns } from "./Vertify.vue?vue&type=template&id=18c3a9ca&scoped=true&"
import script from "./Vertify.vue?vue&type=script&lang=js&"
export * from "./Vertify.vue?vue&type=script&lang=js&"
import style0 from "./Vertify.vue?vue&type=style&index=0&id=18c3a9ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c3a9ca",
  null
  
)

export default component.exports